import type { SyntheticEvent } from 'react';
import { BASE_URL } from '../apiConfig';
import defaultCourseImage from '../assets/images/Screenshot_2.png';

export const DEFAULT_COURSE_IMAGE = defaultCourseImage;

export function resolveCourseImageUrl(imagePath?: string | null): string {
  const trimmed = imagePath?.trim();
  if (!trimmed) return DEFAULT_COURSE_IMAGE;

  if (/^https?:\/\//i.test(trimmed)) return trimmed;

  const path = trimmed.startsWith('/') ? trimmed.slice(1) : trimmed;
  const base = BASE_URL.endsWith('/') ? BASE_URL : `${BASE_URL}/`;
  return `${base}${path}`;
}

export function handleCourseImageError(e: SyntheticEvent<HTMLImageElement>): void {
  e.currentTarget.src = DEFAULT_COURSE_IMAGE;
}
